import theme from "../../../theme";

/**
 * Alternating-stripe row styles for MUI TableRow.
 *
 * @param {number} index - Row index (0-based)
 * @param {Object} [options]
 * @param {boolean} [options.withBorder=true] - Accent rows get a border + bottom divider
 * @param {boolean} [options.startWithWhite=false] - If true, row 0 is white instead of mistGray
 * @param {string} [options.radius=theme.borderRadius.small] - Corner radius on first/last cell
 */

export const getStripedRowStyles = (index, options = {}) => {
  const {
    withBorder = true,
    startWithWhite = false,
    radius = theme.borderRadius.small,
  } = options;

  const isEven = index % 2 === 0;
  const isWhiteRow = startWithWhite ? isEven : !isEven;
  const isAccentRow = !isWhiteRow; // the mistGray row - gets border/radius when withBorder is true

  const base = {
    backgroundColor: isWhiteRow ? "primary.white" : "primary.mistGray",
    borderRadius: 2,
    overflow: "hidden",
    "& td, & th": { border: 0 },
  };

  if (!withBorder) {
    // No-border variant: every row gets rounded corners (Spend table)
    return {
      ...base,
      "& td:first-of-type": {
        borderTopLeftRadius: radius,
        borderBottomLeftRadius: radius,
      },
      "& td:last-of-type": {
        borderTopRightRadius: radius,
        borderBottomRightRadius: radius,
      },
    };
  }

  // Bordered variant: only the accent (mistGray) row gets a border + radius (News table)
  return {
    ...base,
    border: isAccentRow ? "1px solid" : 0,
    borderColor: isAccentRow ? "primary.main60" : "transparent",
    "&:not(:last-of-type)": {
      borderBottom: isAccentRow ? "1px solid" : 0,
      borderBottomColor: "primary.main",
    },
    "& td:first-of-type": {
      borderTopLeftRadius: isAccentRow ? radius : 0,
      borderBottomLeftRadius: isAccentRow ? radius : 0,
    },
    "& td:last-of-type": {
      borderTopRightRadius: isAccentRow ? radius : 0,
      borderBottomRightRadius: isAccentRow ? radius : 0,
    },
  };
};
